
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 17","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M9.6 4.92a48.06 48.06 0 01-9-1.2c3.618 3.505 6.34 6.749 7.51 10.822.2.698.838 1.178 1.563 1.179.643 0 1.208-.43 1.38-1.05 1.15-4.134 3.892-7.41 7.547-10.95a48.06 48.06 0 01-9 1.2zm8.52-3.84c.4.53.48 2.64.48 2.64s-2-.67-2.4-1.2a1.2 1.2 0 111.92-1.44s0 0 0 0zm.48 2.64v3.6"}}),_c('path',{attrs:{"d":"M1.08 1.08C.68 1.61.6 3.72.6 3.72s2-.67 2.4-1.2a1.2 1.2 0 10-1.92-1.44zM.6 3.72v3.6"}})])])
          )
        }
      }
    